import AppConfig from './appConfig';

class ReactApiService {
	
	constructor() {

		this.config = AppConfig();	

		if ( this.config !== null ) {
			this.apiUrl = this.config.apiBaseUrl;
		}
	}
	
	async fetchData(
		{
			method='GET', 
			headers={'Content-Type':'application/json;charset=utf-8'}, 
			body={}
		} = {}
	){
		// console.log( ' reactApiService.js -> this.config.apiBaseUrl :: ', this.config.apiBaseUrl );
		// console.log( ' reactApiService.js -> this.apiUrl 						:: ', this.apiUrl );
		// console.log(`method: ${method}`);
		// console.log('headers:: ', headers);
		let params = {};
		params.method = method;
		params.headers = headers;
		if ( method === 'POST' ) {
			params.body = body;
		}
		const response = await fetch(`${this.apiUrl}`, params);
		if ( ! response.ok ) {
			throw new Error(`Could not fetch ${this.apiUrl}, status ${response.status}`);
			// throw new Error(`Could not fetch data, status ${response.status}`);
		}
		return await response.json();
	}
	
	get(endpoint) {
		endpoint = endpoint || this.config.endPointByDefault;
		if ( this.config === null ) {
			return new Promise((resolve) => { resolve({items:{}}) });
		}
		this.apiUrl = this.config.apiBaseUrl + this.config.endPoints[endpoint]['route'];
		return this.fetchData();
	}
	
	post(params) {
		// console.log('params.endpoint ::',params.endpoint);
		// console.log('params.endpoint ::',this.config.endPoints[params.endpoint]);
		this.apiUrl = this.config.apiBaseUrl + this.config.endPoints[params.endpoint]['route'];
		
		// console.log('this.apiUrl  ::', this.apiUrl );
		// console.log('params.body     ::',params.body);
		// console.log('body    			   ::',params.body);
		return this.fetchData({method:'POST',headers:{},body:JSON.stringify(params.body)});
	}
}

export default ReactApiService;